import { Loader } from "../loader/Loader";
import { type PropsWithChildren, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";

export const LazyFallback = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const resetKey = location?.pathname;
  return (
    <ErrorBoundary
      fallback={<div>Ошибка при загрузке</div>}
      resetKeys={resetKey !== undefined ? [resetKey] : undefined}
    >
      <Suspense fallback={<Loader />}>{children}</Suspense>
    </ErrorBoundary>
  );
};
